import DOMPurify from 'dompurify';

interface ISanitizer {
  sanitize: (markdown: string) => string;
}

// this hook is used to sanitize markdown text before rendering it
export const useSanitizer = (): ISanitizer => {
  const sanitize = (markdown: string) => {
    // to reduce the security risk of allowing the target="_blank", creating a named hook function for adding rel attributes with noopener noreferrer.
    const addRelAttributeHook = (node: Element) => {
      if (node.nodeName === 'A' && node.hasAttribute('target') && node.getAttribute('target') === '_blank') {
        node.setAttribute('rel', 'noopener noreferrer');
      }
    };

    // Add the hook with a reference
    DOMPurify.addHook('afterSanitizeAttributes', addRelAttributeHook);

    try {
      return DOMPurify.sanitize(markdown, {
        FORBID_ATTR: ['rel'],
        ADD_ATTR: ['target'],
      });
    } finally {
      // Always remove the hook, even if sanitize throws an error
      DOMPurify.removeHook('afterSanitizeAttributes', addRelAttributeHook);
    }
  };

  return {
    sanitize,
  };
};
